import script from "./VoucherEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherEditForm.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherEditForm.vue?vue&type=style&index=0&id=4d71bb19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d71bb19"]])

export default __exports__